import { render } from "./staffworkmodel.vue?vue&type=template&id=c4d63938"
import script from "./staffworkmodel.vue?vue&type=script&lang=ts"
export * from "./staffworkmodel.vue?vue&type=script&lang=ts"
script.render = render

export default script